var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-card",
    {
      attrs: {
        title: _vm.app.title,
        imgSrc: _vm.app.imgUrl,
        icon: _vm.app.active ? "check-circle" : "times-circle",
        link: true
      }
    },
    [
      _c(
        "template",
        { attrs: { slot: "header" }, slot: "header" },
        [_c("header-card", { attrs: { integration: _vm.app } })],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { attrs: { slot: "body" }, slot: "body" },
        [_c("body-card", { attrs: { app: _vm.app } })],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14fbdb42", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14fbdb42","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-integrations/components/app-list/app-card/AppCard.vue
// module id = null
// module chunks = 